import React from "react";
import makeStyles from "@mui/styles/makeStyles";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  title: {
    color: theme.palette.brandPrimary,
  },
}));

const ConfirmationDialog = ({
  confirmButtonText,
  declineButtonText,
  message,
  onCancel,
  onConfirm,
  title,
  useCustomTitle,
  useCustomMessage,
  visible,
}) => {
  const classes = useStyles();
  return (
    <Dialog
      maxWidth="xs"
      open={visible}
      onClose={onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {useCustomTitle ? (
          title
        ) : (
          <Typography classes={{ root: classes.title }}>{title}</Typography>
        )}
      </DialogTitle>
      <DialogContent>
        {useCustomMessage ? (
          message
        ) : (
          <DialogContentText id="alert-dialog-description">
            {message}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} style={{ fontWeight: 400 }} autoFocus>
          {declineButtonText || "Cancel"}
        </Button>
        <Button
          onClick={onConfirm}
          style={{ width: "auto" }}
          color="primary"
          variant="contained"
        >
          {confirmButtonText || "Discard"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
